import { CALL_AUTHORIZATION_MANAGEMENT_API } from '../../middleware/authHeaders'
import { AUTHORIZATION_MANAGEMENT_API_ROOT } from '../../config/api'

export const AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_REQUEST =
  'AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_REQUEST'
export const AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_SUCCESS =
  'AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_SUCCESS'
export const AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_FAILURE =
  'AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_FAILURE'

export const searchRoleUsers =
  (contextId, roleId, searchText = '', pageNumber = 1, pageSize = 20) =>
  dispatch => {
    return dispatch({
      [CALL_AUTHORIZATION_MANAGEMENT_API]: {
        method: 'GET',
        endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/users/search/?roleId=${roleId}&searchText=${searchText}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        types: [
          AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_REQUEST,
          AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_SUCCESS,
          AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_FAILURE,
        ],
      },
    })
  }

export const AUTHORIZATION_SEARCH_CONTEXT_USERS_REQUEST =
  'AUTHORIZATION_SEARCH_CONTEXT_USERS_REQUEST'
export const AUTHORIZATION_SEARCH_CONTEXT_USERS_SUCCESS =
  'AUTHORIZATION_SEARCH_CONTEXT_USERS_SUCCESS'
export const AUTHORIZATION_SEARCH_CONTEXT_USERS_FAILURE =
  'AUTHORIZATION_SEARCH_CONTEXT_USERS_FAILURE'

export const searchContextUsers =
  (contextId, searchText = '', pageNumber = 1, pageSize = 20) =>
  dispatch => {
    return dispatch({
      [CALL_AUTHORIZATION_MANAGEMENT_API]: {
        method: 'GET',
        endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/users/search/?searchText=${searchText}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        types: [
          AUTHORIZATION_SEARCH_CONTEXT_USERS_REQUEST,
          AUTHORIZATION_SEARCH_CONTEXT_USERS_SUCCESS,
          AUTHORIZATION_SEARCH_CONTEXT_USERS_FAILURE,
        ],
      },
    })
  }

export const AUTHORIZATION_ADD_USER_ROLE_REQUEST = 'AUTHORIZATION_ADD_USER_ROLE_REQUEST'
export const AUTHORIZATION_ADD_USER_ROLE_SUCCESS = 'AUTHORIZATION_ADD_USER_ROLE_SUCCESS'
export const AUTHORIZATION_ADD_USER_ROLE_FAILURE = 'AUTHORIZATION_ADD_USER_ROLE_FAILURE'

export const addUserRole = (contextId, userId, roleId, isApplicationRole) => dispatch => {
  const payload = {
    [isApplicationRole ? 'applicationRoleId' : 'contextRoleId']: roleId,
  }

  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'POST',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/users/${userId}`,
      body: JSON.stringify(payload),
      types: [
        AUTHORIZATION_ADD_USER_ROLE_REQUEST,
        AUTHORIZATION_ADD_USER_ROLE_SUCCESS,
        AUTHORIZATION_ADD_USER_ROLE_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_REMOVE_USER_ROLE_REQUEST = 'AUTHORIZATION_REMOVE_USER_ROLE_REQUEST'
export const AUTHORIZATION_REMOVE_USER_ROLE_SUCCESS = 'AUTHORIZATION_REMOVE_USER_ROLE_SUCCESS'
export const AUTHORIZATION_REMOVE_USER_ROLE_FAILURE = 'AUTHORIZATION_REMOVE_USER_ROLE_FAILURE'

export const removeUserRole = (contextId, userId, roleId) => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'DELETE',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/contexts/${contextId}/users/${userId}/roles/${roleId}`,
      types: [
        AUTHORIZATION_REMOVE_USER_ROLE_REQUEST,
        AUTHORIZATION_REMOVE_USER_ROLE_SUCCESS,
        AUTHORIZATION_REMOVE_USER_ROLE_FAILURE,
      ],
    },
  })
}

const selectAuthorizationUsersSlice = state => state.authorizationManagement.authorizationUsers

export const selectUsersSearchResults = state =>
  selectAuthorizationUsersSlice(state).usersSearchResults

const initialState = {
  usersSearchResults: null,
}

const authorizationUsers = (state = initialState, { type, payload } = {}) =>
  ({
    [AUTHORIZATION_SEARCH_CONTEXT_ROLE_USERS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      usersSearchResults: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default authorizationUsers
